import * as React from 'react';
import rightArrowCircled from '../../../assets/right-arrow-circled.svg';

interface RightArrowCircledIconProps {
    size?: number;
    style?: React.CSSProperties;
}

const RightArrowCircledIcon = (props: RightArrowCircledIconProps) => {
    return <img src={rightArrowCircled} height={props.size ?? 16} width={props.size ?? 16} style={props.style} />;
};

export default RightArrowCircledIcon;
